import { Box, Grid, Skeleton, Theme, useMediaQuery } from '@mui/material';
import _ from 'lodash';
import { programDetailStyles } from '../styles';
import { ProgramStickyCardSkeleton } from './ProgramStickyCardSkeleton';

export const ProgramDetailHeaderSkeleton: React.FC = () => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  return (
    <Box>
      <Box
        className={isDesktop ? '-container-fluid-left container-fluid-left' : '-container-fluid container-fluid'}
        sx={programDetailStyles.headerContent}
      >
        <Skeleton sx={{ mb: 3 }} variant="rectangular" height="3rem" width="clamp(15rem, 25rem, 100%)" />
        <Grid direction="column" container rowSpacing={1}>
          <Grid item>
            <Grid container spacing={1.5}>
              <Grid item>
                <Skeleton sx={{ mt: 0.5 }} variant="circular" height="1.25rem" width="1.25rem" />
              </Grid>
              <Grid item>
                <Skeleton width="12.5rem" />
                <Skeleton width="12.5rem" />
              </Grid>
            </Grid>
          </Grid>
          {!isDesktop &&
            _.times(4, _.stubArray).map((_item, index) => (
              <Grid key={index} item>
                <Skeleton width="7.5rem" />
              </Grid>
            ))}
        </Grid>
        {!isDesktop && (
          <Box>
            <ProgramStickyCardSkeleton hideInfo />
          </Box>
        )}
      </Box>
    </Box>
  );
};
